export default "__VITE_ASSET__BMeU1_qE__"